// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

const styles = theme => ({
  mainContainer: {
    marginTop: 200,
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down(1800)]: {
      marginTop: 180
    },
    [theme.breakpoints.down(1600)]: {
      marginTop: 160
    },
    [theme.breakpoints.down(1368)]: {
      marginTop: 120
    },
    [theme.breakpoints.down(1025)]: {
      marginTop: 80,
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    [theme.breakpoints.down(426)]: {
      marginTop: 40,
      flexBasis: '100%',
    },
  },
});

export default styles;
